const ProjectActivityEventCollectionFields = [
	{
		ID: "CreatedOn",
		Label: "Date",
	},
	{
		ID: "SourceType",
		Label: "Category",
	},
	{
		ID: "SourceEventType",
		Label: "Event Type",
	},
	{
		ID: "SourceName",
		Label: "Source",
	},
	{
		ID: "CreatedByUserName",
		Label: "User",
	},
];

export default ProjectActivityEventCollectionFields;
